import React, { useEffect, useState } from "react";
import VendorHeader from "../../CustomComponents/Property/VendorHeader/VendorHeader";
import SideBar from "../../CustomComponents/Property/SideBar/SideBar";
import RatePlans from "../../CustomComponents/Property/RatePlans/RatePlans";

function RatePlansPage({ allPropertiesPage }) {
  return (
    <>
      <div className="sidebar_main_div new_sidebar_main_div">
        <SideBar allPropertiesPage={false} />
        <div className="agent-info-container">
          <VendorHeader showSelectProperty={true} vendorProperty={false} />

          <RatePlans />
        </div>
      </div>
    </>
  );
}

export default RatePlansPage;
